import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SettingsSvg } from './assets/settings.svg';

const SettingsIcon = React.forwardRef((args, ref) => <SvgIcon component={SettingsSvg} ref={ref} {...args} />);

export default SettingsIcon;
